enum Types {
  SET_FILTER_VALUES = 'SET_FILTER_VALUES',
  SET_CLIENTS_FILTER_VALUES = 'SET_CLIENTS_FILTER_VALUES',
}

export default Types;
